module.exports = __webpack_public_path__ + "static/promlens-hero-screenshot-7d453e779cf47c6fcec1de8823049257.png";